'use strict';
'use es6';
// This is an auto-generated file. Please do not edit directly.
// For instructions on editing source files, please see:
// https://git.hubteam.com/HubSpot/UIComponents/blob/master/UIComponents/docs/open-source.md
// *****************************************************************************************

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  background-color: currentColor;\n  border: 0;\n  height: 1px;\n  // Set min-height and width so that it will never be shrunk inside a flex container\n  min-height: 1px;\n  width: 100%;\n'], ['\n  background-color: currentColor;\n  border: 0;\n  height: 1px;\n  // Set min-height and width so that it will never be shrunk inside a flex container\n  min-height: 1px;\n  width: 100%;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// todo: replace color

var StyledHr = /*#__PURE__*/_styledComponents2.default.hr.withConfig({
  displayName: 'Hr__StyledHr'
}).withConfig({
  displayName: 'Hr__StyledHr'
})(_templateObject);

var Hr = function Hr(props) {
  return _react2.default.createElement(StyledHr, props);
};

Hr.displayName = 'Hr';

exports.default = Hr;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/vendor/canvas/Hr.js
// module id = 344
// module chunks = 0